import { render, staticRenderFns } from "./sendButton.vue?vue&type=template&id=7389797a&scoped=true&"
import script from "./sendButton.vue?vue&type=script&lang=js&"
export * from "./sendButton.vue?vue&type=script&lang=js&"
import style0 from "./sendButton.vue?vue&type=style&index=0&id=7389797a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7389797a",
  null
  
)

export default component.exports